import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaTimes, FaPaypal } from 'react-icons/fa';

const DonationModal = ({ isOpen, onClose, causeTitle }) => {
  if (!isOpen) return null;

  return (
    <AnimatePresence>
      <div className="fixed inset-0 z-[100] flex items-center justify-center px-4">
        {/* Backdrop */}
        <motion.div 
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={onClose}
          className="absolute inset-0 bg-black/80"
        />

        {/* Modal Content */}
        <motion.div 
          initial={{ scale: 0.9, opacity: 0, y: 20 }}
          animate={{ scale: 1, opacity: 1, y: 0 }}
          exit={{ scale: 0.9, opacity: 0, y: 20 }}
          className="relative bg-white w-full max-w-2xl overflow-hidden shadow-2xl"
        >
          <div className="bg-[#221f1f] p-8 text-center relative text-white">
            <button 
              onClick={onClose}
              className="absolute top-4 right-4 bg-white/20 hover:bg-white/40 rounded-full p-2 transition-colors"
            >
              <FaTimes size={18} />
            </button>
            <h2 className="text-2xl font-serif font-bold uppercase tracking-wide">Donate Today</h2>
            <p className="text-sm mt-2 opacity-90 uppercase tracking-widest">
              You are donating to: <span className="font-bold underline">{causeTitle}</span>
            </p>
          </div>

          {/* Form Body */}
          <div className="p-10 max-h-[70vh] overflow-y-auto custom-scrollbar">
            <form className="space-y-8">
              
              {/* Amount Section */}
              <div>
                <label className="block text-gray-500 text-sm mb-4 font-medium">Your Donation</label>
                <div className="flex flex-wrap gap-3">
                  {['$20', '$30', '$50', '$70'].map((amt) => (
                    <button 
                      key={amt}
                      type="button"
                      className="bg-[#221f1f] text-white px-6 py-3 font-bold hover:bg-[#f9b50b] transition-colors"
                    >
                      {amt}
                    </button>
                  ))}
                  <input 
                    type="text" 
                    placeholder="Type your amount ( $ )" 
                    className="border border-gray-200 p-3 flex-grow focus:outline-none focus:border-[#f9b50b]"
                  />
                </div>
              </div>

              {/* Personal Details */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="col-span-2 text-gray-500 text-sm font-medium border-b pb-2">Your Details</div>
                <input type="text" placeholder="First name" className="border border-gray-200 p-3 focus:outline-none focus:border-[#f9b50b]" />
                <input type="text" placeholder="Last name" className="border border-gray-200 p-3 focus:outline-none focus:border-[#f9b50b]" />
                <input type="text" placeholder="Phone" className="border border-gray-200 p-3 focus:outline-none focus:border-[#f9b50b]" />
                <input type="email" placeholder="Email" className="border border-gray-200 p-3 focus:outline-none focus:border-[#f9b50b]" />
              </div>

              {/* Card Info */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="col-span-2 text-gray-500 text-sm font-medium border-b pb-2">Card Information</div>
                <input type="text" placeholder="Card Number" className="border border-gray-200 p-3 focus:outline-none focus:border-[#f9b50b]" />
                <input type="text" placeholder="CVC" className="border border-gray-200 p-3 focus:outline-none focus:border-[#f9b50b]" />
                <input type="text" placeholder="Expiration Month (MM)" className="border border-gray-200 p-3 focus:outline-none focus:border-[#f9b50b]" />
                <input type="text" placeholder="Expiration Year (YYYY)" className="border border-gray-200 p-3 focus:outline-none focus:border-[#f9b50b]" />
                <textarea placeholder="Extra Note" className="col-span-2 border border-gray-200 p-3 h-24 focus:outline-none focus:border-[#f9b50b]"></textarea>
              </div>

              {/* Footer Buttons */}
              <div className="flex flex-col sm:flex-row justify-between items-center gap-4 pt-4">
                <button className="w-full sm:w-auto bg-[#f9b50b] text-white px-10 py-3 font-bold uppercase tracking-widest hover:bg-[#221f1f] transition-colors">
                  Donate
                </button>
                <button className="w-full sm:w-auto bg-[#f9b50b] text-white px-8 py-3 font-bold flex items-center justify-center gap-2 hover:bg-[#221f1f] transition-colors">
                  <FaPaypal /> Give by Paypal
                </button>
              </div>
            </form>
          </div>
        </motion.div>
      </div>
    </AnimatePresence>
  );
};

export default DonationModal;